type OfficialActivityDraft = {
  title: string;
  city: string;
  location: string;
  startsAt: string;
  endsAt: string;
  capacity: string;
};

export function validateOfficialActivity(
  draft: OfficialActivityDraft,
): string | null {
  if (
    !draft.title.trim() ||
    !draft.city.trim() ||
    !draft.location.trim() ||
    !draft.startsAt ||
    !draft.endsAt
  ) {
    return "请填写活动名称、城市、地点与起止时间";
  }

  const startsAt = new Date(draft.startsAt);
  const endsAt = new Date(draft.endsAt);
  if (
    Number.isNaN(startsAt.getTime()) ||
    Number.isNaN(endsAt.getTime()) ||
    endsAt <= startsAt
  ) {
    return "结束时间必须晚于开始时间";
  }

  const capacity = Number(draft.capacity);
  if (!Number.isInteger(capacity) || capacity < 0) {
    return "活动容量必须是非负整数";
  }

  return null;
}
